import React from 'react'
import './styles.scss'
import COLORS from '../../styles/colors'

import Area from '../../assets/svgs/details/area'
import ParkingSpots from '../../assets/svgs/ParkingSpots'
import Apartment from '../../assets/svgs/Apartment'
import House from '../../assets/svgs/House'

import Mic from '../../assets/svgs/Mic'
import Company from '../../assets/svgs/Company'
import { PropertyAddress, PropertyInfo } from 'types/propertyAnnouncement'

interface Props {
  id?: string
  info: PropertyInfo
  address: PropertyAddress
  selected?: boolean
  onClick?: (property: any) => void | void
}

const PropertyCard = ({
  id,
  info,
  address: { city, neighbourhood, street, number, complement, zip_code },
  selected,
  onClick,
}: Props) => {
  let className = 'property-card-container'
  if (selected) className += ' selected'
  const color = selected ? COLORS.brand.primaryDark : COLORS.greyscale.medium

  const [type, TypeIcon] = (() => {
    switch (info.type) {
      case 'house':
        return ['CASA', <House style={{ width: 33, height: 33, transform: 'translateY(-3px)', color }} />]
      case 'apartment':
        return ['APTO.', <Apartment color={color} />]
      default:
        return [
          'ESTÚDIO/\nKITNET',
          <div style={{ width: 33, height: 33 }}>
            <Company color={color} />
            <Mic color={color} />
          </div>,
        ]
    }
  })()

  const propertyAddress = [street, number, complement, zip_code].filter((e) => e != null).join(' , ')
  return (
    //@ts-ignore
    <div onClick={onClick ? () => onClick(id) : () => {}} className={className}>
      <header className='flex-one'>{`${neighbourhood}, ${city}`}</header>
      <main className='content flex-one'>
        <div className='property-info'>
          {TypeIcon}
          <div className='info-text'>
            <span>Tipo:</span>
            <span className='content'>{type}</span>
          </div>
        </div>
        <div className='property-info'>
          <Area color={color} />
          <div className='info-text'>
            <span>Área:</span>
            <span className='content'>{`${info.area} M²`}</span>
          </div>
        </div>
        <div className='property-info'>
          <ParkingSpots
            style={{
              width: 43,
              height: 43,
              transform: 'translateY(-7px)',
            }}
            color={color}
          />
          <div className='info-text'>
            <span>Vagas:</span>
            <span className='content'>{info.car_slots}</span>
          </div>
        </div>
      </main>
      <footer className='flex-one'>{propertyAddress}</footer>
    </div>
  )
}

export default PropertyCard
